export default __webpack_public_path__ + "static/automotive-a7b627ecafc1338347eace74783fd054.jpeg";